// extracted by mini-css-extract-plugin
export const partners = "F_cf";
export const partners_inner = "F_cg";
export const partners_list = "F_ch";
export const partners_item = "F_cj";